export default {
    about_doctor: "About the doctor",
    account_manager: "Account manager",
    activated: "Activated",
    additional_info: "Additional information",
    administrator: "Manager",
    administrators: "Managers",
    amount_of_doctors: "Number of doctors",
    are_you_sure_you_want_to_delete_field: "Are you sure you want to delete field",
    assistants: "Assistants",
    backup_code: "Backup code",
    block: "Block",
    block_noun: "Block",
    browse_computer: "Browse computer",
    by_cabinets: "By office",
    by_days: "By days",
    by_days_of_week: "By week days",
    by_even_days: "By even days",
    by_odd_days: "By odd days",
    cabinet: "Cabinet",
    cabinets: "Cabinets",
    chair: "Chair",
    chairs: "Chairs",
    clinic_access_request: "Clinic access request",
    config: "Configuration",
    confirm_password: "Confirm password",
    curator: "Curator",
    curators: "Curators",
    dentist_plus_tech_support_requests_access_to_your_clinic: "Dentist+ Tech support requests access to your clinic",
    doctor_position: "Doctor's position",
    doctor_specialty: "Doctor's specialty",
    enter_backup_code_note: "Enter one of the backup codes that you received when you activated two-factor authentication. ",
    enter_code_from_authorization_app: "Enter the code from the two-factor authentication application on your phone",
    field: "Field",
    fields: "Fields",
    functionality: "Functionality",
    login_and_password: "Login and Password",
    manual_pay_system: "Manual pay system",
    not_worked: "Not worked",
    partner: "Partner",
    password_does_not_match_confirmation: "Password does not match with confirmation",
    password_requirement_min_length: "At least {min} characters",
    password_requirement_mixed_case: "Latin uppercase and lowercase letters",
    password_requirement_number: "At least one digit",
    password_requirement_symbol: "At least one special character",
    percent: "Interest",
    period_from: "Period from",
    period_to: "Period to",
    phone2: "Phone 2",
    profession: "Profession",
    rate: "Rate",
    rate_per_day: "Rate per day",
    rate_per_hour: "Rate per hour",
    rate_per_month: "Rate per month",
    reserve_codes: "Reserve codes",
    roles: "Roles",
    sale_good_percent: "Percentage from sales of goods",
    schedule_conflicts_found: "Schedule conflicts found with current records",
    seller: "Salesman",
    sessions: "Sessions",
    staff: "Staff",
    take_photo: "Take photo",
    technics: "Technicians",
    turn_on: "Turn on",
    turned_off: "Disabled",
    two_factor_authorization: "Two-factor authentication",
    two_factor_authorization_setup_successfully: "Two-factor authentication activated successfully",
    twofactor_setup_instructions: "<ul><li>Download an authenticator app (e.g. Google Authenticator, Microsoft Authenticator, Yandex.Key) from the App Store or Google Play.</li><li>Tap 'Add Code'/'+' in the app on your phone and scan the QR code displayed on your computer screen.</li><li>Enter the 6-digit code generated by the app in the appropriate field below the QR code to complete ",
    use_app_code: "Use standard code",
    use_backup_code: "Use backup code",
    user_data: "User data",
    user_will_assigned_rights_selected_for_that_role: "User will be assigned rights selected for that role",
    weekend: "Day off",
    without_warehouse_form_note: "If not attached to a warehouse, materials will be written off from the main warehouse or from a warehouse attached to a chair",
    work_day: "Work day",
    work_days: "Work days",
    work_schedule: "Work schedule",
    work_time: "Work hours",
    worked: "Worked"
}
